import React, { useState, createContext, useEffect } from 'react';
import Client from 'shopify-buy';
import { Sentry } from 'react-activity';
import 'react-activity/dist/react-activity.css';

export const ProductsContext = createContext([]);
export const CheckoutsContext = createContext([]);
export const ShopsContext = createContext([]);
export const CartContext = createContext([]);

const client = Client.buildClient({
    domain: 'conecuh-brands.myshopify.com',
    storefrontAccessToken: 'fd73aae121a8110089143a1d450c7b6e'
});

export const ProductProvider = (props) =>{
    const [products, setProducts] = useState([])
    const [hats, setHats] = useState([])
    const [accessarries, setAccessarries] = useState([])
    const [shirts, setShirts] = useState([])

    const [checkout, setCheckout] = useState([])
    const [shop, setShop] = useState([])
    const [showCart, setShowCart] = useState(false)
    const [renderData, setRenderData] = useState(false)

    useEffect(() => {
      setRenderData(false)



        // client.product.fetchAll().then((products) => {
        //   // Do something with the products
        //   console.log(products);
        // });


        // Fetch all collections, including their products
        // client.collection.fetchAllWithProducts().then((collections) => {
        //   // Do something with the collections
        //   // console.log(collections);
        //   console.log(collections);
        // });


        client.checkout.create().then((res) => {          
          setCheckout(res)
          client.collection.fetchWithProducts("Z2lkOi8vc2hvcGlmeS9Db2xsZWN0aW9uLzI3NjUzMjgyMjE3MQ==", {productsFirst: 100}).then((collection) => {

          //  console.log(collection);
            setProducts(collection.products)  
            setHats(collection.products)                      
            client.collection.fetchWithProducts("Z2lkOi8vc2hvcGlmeS9Db2xsZWN0aW9uLzE2OTk3NjA3MDI4MQ==", {productsFirst: 100}).then((collection) => {
              setProducts(products  => products.concat(collection.products)) 
              setShirts(collection.products)
              client.collection.fetchWithProducts("Z2lkOi8vc2hvcGlmeS9Db2xsZWN0aW9uLzE4MTMzODIxMDQ0MQ==", {productsFirst: 100}).then((collection) => {
                setProducts(products  => products.concat(collection.products)) 
                setAccessarries(collection.products)
                client.shop.fetchInfo().then((res) => {
                  setShop(res)
                  setRenderData(true)
                });
              });
            });            
          });
        });          
    },[]);
     
    if(renderData){

      // console.log(products)

      return(      
        <ProductsContext.Provider value={{all_products: products,hats: hats, shirts: shirts, accessarries: accessarries}}>
          <CheckoutsContext.Provider value={[checkout, setCheckout]}>
            <ShopsContext.Provider value={shop}>
              <CartContext.Provider value={[showCart, setShowCart]}>
                {props.children}
              </CartContext.Provider>                 
            </ShopsContext.Provider>         
          </CheckoutsContext.Provider>            
        </ProductsContext.Provider>
      )
    }
    else{
      return(
      <div style={{height:"100vh",textAlign:"center", overflow: "hidden"}} className="loader-bg">
        <Sentry />
      </div>
      )
    }    
}



// WEBPACK FOOTER //
// ./src/components/products/productsContext.js